exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav{-webkit-overflow-scrolling:auto!important}aside a{cursor:pointer}#pos{padding-top:64px}a{cursor:pointer}.w-icon{width:22px}", ""]);

// exports
